
import { ThemeState } from '../../types/chatbot.types';

export const defaultTheme = (): ThemeState => ({
userMsgBg: 'linear-gradient(90deg, rgba(171, 202, 217, 1) 0%, rgba(84, 132, 197, 1) 100%)',
userMsgFont: '#ffffff',
botMsgBg: '#ffffff',
botMsgFont: '#000000',
sendBtn: '#a29090',
bg: '#f0f6ff',
inputTextBg: '#dedede',
inputTextFont: '#000000',
inputBorder: '#ffff0000',
fontFamily: 'Trebuchet MS, sans-serif',
welcome: 'Hello! How can I help you today?',
placeholder: 'Type your message...',
headerBg: '#111827', 
headerTextFont:"#fff"
});

export const mapToApiSettings = (t: ThemeState) => ({
schemaVersion: 1,
settings: {
userMessageBgColor: t.userMsgBg,
userMessageFontColor: t.userMsgFont,
botMessageBgColor: t.botMsgBg,
botMessageFontColor: t.botMsgFont,
sendButtonColor: t.sendBtn,
bgColor: t.bg,
inputTextBgColor: t.inputTextBg,
inputTextFontColor: t.inputTextFont,
inputFieldBorderColor: t.inputBorder,
fontFamily: t.fontFamily,
welcomeMessage: t.welcome,
placeholderText: t.placeholder,
headerBgColor:t.headerBg,
headerTextFont:t.headerTextFont

},
});

export const readThemeFromApiShape = (resp: any): ThemeState | null => {
if (!resp) return null;
const s = resp.themeConfig?.settings ?? resp.themeSettings?.settings ?? resp.settings ?? null;
if (!s) return null;
return {
userMsgBg: s.userMessageBgColor ?? s.userMessageBg ?? defaultTheme().userMsgBg,
userMsgFont: s.userMessageFontColor ?? s.userMessageFont ?? defaultTheme().userMsgFont,
botMsgBg: s.botMessageBgColor ?? s.botMsgBg ?? defaultTheme().botMsgBg,
botMsgFont: s.botMessageFontColor ?? s.botMsgFont ?? defaultTheme().botMsgFont,
sendBtn: s.sendButtonColor ?? s.sendBtn ?? defaultTheme().sendBtn,
bg: s.bgColor ?? s.bg ?? defaultTheme().bg,
inputTextBg: s.inputTextBgColor ?? s.inputTextBg ?? defaultTheme().inputTextBg,
inputTextFont: s.inputTextFontColor ?? s.inputTextFont ?? defaultTheme().inputTextFont,
inputBorder: s.inputFieldBorderColor ?? s.inputBorder ?? defaultTheme().inputBorder,
fontFamily: s.fontFamily ?? defaultTheme().fontFamily,
welcome: s.welcomeMessage ?? s.welcome ?? defaultTheme().welcome,
placeholder: s.placeholderText ?? s.placeholder ?? defaultTheme().placeholder,
headerBg: s.headerBgColor ?? s.headerBgColor ?? defaultTheme().headerBg,
headerTextFont:s.headerTextFont

};
};
